import { Channel } from './Channel';

/**
 * A managed collection of channels.
 */
export class ChannelRegistry {
    // A map of channel IDs to channels.
    private channels: { [key: string]: Channel<any> } = {};

    /** Gets a channel by ID, or undefined if it's not registered. */
    get(id: string): Channel<unknown> | undefined {
        return this.channels[id];
    }

    /** Creates a new channel and registers it. */
    create<T = unknown>(): Channel<T> {
        const channel = new Channel<T>();
        this.channels[channel.id] = channel as Channel<any>;
        return channel;
    }

    /** Removes a channel by ID, and unsubscribes all subscribers. Does nothing if the channel is not registered. */
    remove(channel: Channel<any>) {
        channel?.unsubscribeAll();
        delete this.channels[channel.id];
    }
}
